import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import withCurrentMediaSource from '../../../_hocs/withCurrentMediaSource';
import { getTransKeyForMediaSourceType, getAllMediaSourceTypes } from '../_helpers';
import mediaSourceMenuMobileStyles from './MediaSourceMenuMobile.scss';
const enhance = compose(withCurrentMediaSource);
export const MediaSourceMenu = ({ currentMediaSource, mediaSourceTypes, changeCurrentMediaSource })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: mediaSourceMenuMobileStyles['root']
    }, t(getTransKeyForMediaSourceType(currentMediaSource)), /*#__PURE__*/ React.createElement(ArrowDownIcon, {
        className: mediaSourceMenuMobileStyles['icon']
    }), /*#__PURE__*/ React.createElement("select", {
        value: currentMediaSource,
        onChange: (event)=>changeCurrentMediaSource(event.target.value)
    }, (mediaSourceTypes || getAllMediaSourceTypes()).map((mediaSourceType, key)=>{
        return /*#__PURE__*/ React.createElement("option", {
            key: key,
            value: mediaSourceType
        }, t(getTransKeyForMediaSourceType(mediaSourceType)));
    })));
};
MediaSourceMenu.displayName = 'MediaSourceMenu';
export default enhance(MediaSourceMenu);
